import { getCheckedKeys as C } from "./check.js";
import { defaultGetChildren as E, isLeaf as F, isShallowLoaded as S, unwrapCheckedKeys as v, unwrapIndeterminateKeys as b, toArray as A, getNonLeafKeys as k, isNodeInvalid as D, isDisabled as M, isIgnored as j, isGroup as V, defaultGetKey as q } from "./utils.js";
import { getPath as z } from "./path.js";
import { moveMethods as B, getFirstAvailableNode as H } from "./move.js";
import { flatten as J } from "./flatten.js";
import { contains as Q } from "./contains.js";
function G(p, d, o, a, s, K = null, l = 0) {
  const g = [];
  return p.forEach((c, f) => {
    var i;
    process.env.NODE_ENV !== "production" && D(c, s) && console.error("[treemate]: node", c, "is invalid");
    const r = Object.create(a);
    if (r.rawNode = c, r.siblings = g, r.level = l, r.index = f, r.isFirstChild = f === 0, r.isLastChild = f + 1 === p.length, r.parent = K, !r.ignored) {
      const u = s(c);
      Array.isArray(u) && (r.children = G(u, d, o, a, s, r, l + 1));
    }
    g.push(r), d.set(r.key, r), o.has(l) || o.set(l, []), (i = o.get(l)) === null || i === void 0 || i.push(r);
  }), g;
}
function U(p, d = {}) {
  var o;
  const a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), { getDisabled: K = M, getIgnored: l = j, getIsGroup: g = V, getKey: c = q } = d, f = (o = d.getChildren) !== null && o !== void 0 ? o : E, i = d.ignoreEmptyChildren ? (e) => {
    const t = f(e);
    return Array.isArray(t) ? t.length ? t : null : t;
  } : f, r = Object.assign({
    get key() {
      return c(this.rawNode);
    },
    get disabled() {
      return K(this.rawNode);
    },
    get isGroup() {
      return g(this.rawNode);
    },
    get isLeaf() {
      return F(this.rawNode, i);
    },
    get shallowLoaded() {
      return S(this.rawNode, i);
    },
    get ignored() {
      return l(this.rawNode);
    },
    contains(e) {
      return Q(this, e);
    }
  }, B), u = G(p, a, s, r, i);
  function O(e) {
    if (e == null)
      return null;
    const t = a.get(e);
    return t && !t.isGroup && !t.ignored ? t : null;
  }
  function w(e) {
    if (e == null)
      return null;
    const t = a.get(e);
    return t && !t.ignored ? t : null;
  }
  function P(e, t) {
    const n = w(e);
    return n ? n.getPrev(t) : null;
  }
  function I(e, t) {
    const n = w(e);
    return n ? n.getNext(t) : null;
  }
  function _(e) {
    const t = w(e);
    return t ? t.getParent() : null;
  }
  function x(e) {
    const t = w(e);
    return t ? t.getChild() : null;
  }
  const h = {
    treeNodes: u,
    treeNodeMap: a,
    levelTreeNodeMap: s,
    maxLevel: Math.max(...s.keys()),
    getChildren: i,
    getFlattenedNodes(e) {
      return J(u, e);
    },
    getNode: O,
    getPrev: P,
    getNext: I,
    getParent: _,
    getChild: x,
    getFirstAvailableNode() {
      return H(u);
    },
    getPath(e, t = {}) {
      return z(e, t, h);
    },
    getCheckedKeys(e, t = {}) {
      const { cascade: n = !0, leafOnly: m = !1, checkStrategy: N = "all", allowNotLoaded: y = !1 } = t;
      return C({
        checkedKeys: v(e),
        indeterminateKeys: b(e),
        cascade: n,
        leafOnly: m,
        checkStrategy: N,
        allowNotLoaded: y
      }, h);
    },
    check(e, t, n = {}) {
      const { cascade: m = !0, leafOnly: N = !1, checkStrategy: y = "all", allowNotLoaded: L = !1 } = n;
      return C({
        checkedKeys: v(t),
        indeterminateKeys: b(t),
        keysToCheck: e == null ? [] : A(e),
        cascade: m,
        leafOnly: N,
        checkStrategy: y,
        allowNotLoaded: L
      }, h);
    },
    uncheck(e, t, n = {}) {
      const { cascade: m = !0, leafOnly: N = !1, checkStrategy: y = "all", allowNotLoaded: L = !1 } = n;
      return C({
        checkedKeys: v(t),
        indeterminateKeys: b(t),
        keysToUncheck: e == null ? [] : A(e),
        cascade: m,
        leafOnly: N,
        checkStrategy: y,
        allowNotLoaded: L
      }, h);
    },
    getNonLeafKeys(e = {}) {
      return k(u, e);
    }
  };
  return h;
}
export {
  U as createTreeMate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/treemate@0.3.11/~/treemate/es/create.js
// module id = 205
// module chunks = 41